import { Typography } from "@mui/material"

export function ConditionalProblem({ item }) {
    return (
        <Typography variant="caption" color="error" data-cy="conditional-trade-problem">
            {item}
        </Typography>
    )
}
